import React, { useState } from 'react';
const faqs = [{
  q: '¿Cómo recibo el MegaPack después de comprar?',
  a: 'Inmediatamente después del pago recibís el link de descarga por email. Acceso en menos de 5 minutos. Sin espera, sin envío físico.'
}, {
  q: '¿Los 6 bonos están en las dos ofertas?',
  a: 'Sí. Los 6 bonos están incluidos en el MegaPack estándar y en el combo Elite. La única diferencia es que el combo Elite incluye el Manual del DT Ganador.'
}, {
  q: '¿Sirve si soy profe nuevo o con poca experiencia?',
  a: 'Es exactamente para vos. Cada sesión está redactada de principio a fin. No necesitás saber de táctica para usarlo: el material te guía paso a paso.'
}, {
  q: '¿Por qué elegir el combo con el Manual del DT Ganador?',
  a: 'Si solo entrenás, el estándar alcanza. Si el sábado también dirigís partidos, el Manual te da lo que falta: scouting, ajustes por marcador, charlas y jugadas de pizarrón.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días sin preguntas. Escribís a soporteprofepack@gmail.com y te devolvemos el 100%. Sin formularios, sin justificaciones.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-[#0a0a0a] py-12 px-4" data-id="element-52">
      <div className="max-w-2xl mx-auto" data-id="element-53">
        <h2 className="text-2xl sm:text-3xl font-black text-white text-center mb-8" data-id="element-54">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-2" data-id="element-55">
          {faqs.map((faq, i) => <div key={i} className={`rounded-xl border transition-colors ${openIndex === i ? 'border-[#00C853] bg-[#000d08]' : 'border-[#00C853]/20 bg-black'}`} data-id="element-56">
              <button className="w-full text-left px-4 py-3 sm:py-4 flex items-center justify-between gap-3" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-57">
                <span className="text-white font-bold text-sm" data-id="element-58">{faq.q}</span>
                <span className={`text-[#00C853] text-lg flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-45' : ''}`} data-id="element-59">
                  +
                </span>
              </button>
              {openIndex === i && <div className="px-4 pb-4" data-id="element-60">
                  <div className="h-px bg-[#00C853]/20 mb-3" data-id="element-61" />
                  <p className="text-gray-300 text-xs sm:text-sm leading-relaxed" data-id="element-62">
                    {faq.a}
                  </p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}